import {defineMessages, FormattedMessage} from 'react-intl';
import {view} from '@sail/ui/deprecated';
import {ConversationParticipant} from '@stripe-internal/conversations-client';
import {useMemo} from 'react';
import {MetaRow} from './MetaRow';
import {useNewUniversalHelpDesign} from '../../FeatureFlagsProvider';
import {useTheme} from '../../ThemeProvider';

const messages = defineMessages({
  participantJoined: {
    id: 'conversations_ui.chat.row.participantJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: '{name} has joined.',
  },
  supportAgentJoined: {
    id: 'conversations_ui.chat.row.supportAgentJoined',
    description: 'Message to show in a conversation when someone joins.',
    defaultMessage: '{name}, Stripe support agent, has joined the chat.',
  },
});

export const JoinRow = ({
  role,
  name,
}: {
  role?: ConversationParticipant['role'];
  name: string;
}) => {
  const theme = useTheme();
  const useNewDesigns = useNewUniversalHelpDesign();

  const message = useMemo(() => {
    if (useNewDesigns && role === 'agent' && !theme.messageKey) {
      return messages.supportAgentJoined;
    }

    return messages.participantJoined;
  }, [useNewDesigns, role, theme]);

  return (
    <view.div data-testid="join-row">
      <MetaRow>
        <FormattedMessage {...message} values={{name}} />
      </MetaRow>
    </view.div>
  );
};

export default JoinRow;
